import Vue from 'vue'
import Router from 'vue-router'

// Containers
const LoginContainer = () => import('@/containers/LoginContainer')
const TheContainer = () => import('@/containers/TheContainer')

const UserManagement = () => import('@/views/user-management/Index')
const Users = () => import('@/views/user-management/users/All')
const Roles = () => import('@/views/user-management/roles/All')


const ExportAttendance = () => import('@/views/export/ExportAttendance')
const ImportSettings = () => import('@/views/import/ImportSettings')

const MyAccount = () => import('@/views/MyAccount')

const Camera = () => import('@/views/attendance/Camera')
const Records = () => import('@/views/attendance/Records')
Vue.use(Router)

export default new Router({
  base:'/',
  //base:'/franco_time_log/build/',
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
      {
          path: '/login',
          name: 'Login',
          component: LoginContainer
      },
      {
          path: '/',
          redirect: '/attendance',
          name: 'Home',
          component: TheContainer,
          children: [
              {
                  path: '/attendance',
                  name: 'Attendance',
                  component: Camera
              },
              {
                  path: '/records',
                  name: 'Records',
                  component: Records
              },
              // {
              //     path: '/export-attendance',
              //     name: 'Export Attendance',
              //     component: ExportAttendance
              // },
              // {
              //     path: '/import-settings',
              //     name: 'Import Settings',
              //     component: ImportSettings
              // },
              {
                  path: '/my-account',
                  name: 'My Account',
                  component: MyAccount
              },
              {
                  path: '/user-management',
                  redirect: '/user-management/users',
                  name: 'User Management',
                  component: UserManagement,
                  children: [
                      {
                          path: '/user-management/users',
                          name: 'Users',
                          component: Users
                      },
                      {
                          path: '/user-management/roles',
                          name: 'Roles',
                          component: Roles
                      }
                  ]
              },


          ]
      },
      
  ]
}

